/* eslint-disable */
import Card from "./Card";
import a11yFocusTrap from 'Helpers/focusTrap.js'
import hideElements from 'Helpers/hideElements.js';

const HubFilter = () => {
  const body = document.querySelector('body');
  const hubPage = document.querySelector('.page--hub');
  const hubFilter = document.querySelector('.hub-filter');
  let breakpoint = body.getAttribute('data-breakpoint');

  if (!hubFilter) {
    return false;
  }

  const verticalsDesktopContainer = document.querySelector('.hub-filter__verticals--desktop');
  const verticalsMobileContainer = document.querySelector('.hub-filter__verticals--mobile');

  const hubSearch = document.querySelector('.hub-filter__search');
  const hubSearchToggler = document.querySelector('.hub-filter__selections-toggle');
  const optionsTypeToggler = document.querySelectorAll('.search-types-toggler');
  const optionsSetToggler = document.querySelector('.search-set-toggler');

  const selections = document.querySelector('.hub-filter__selections');
  const selectionsList = document.querySelector('.filter-selections');
  const filterClose = document.querySelector('.filter-close');

  let verticals = document.querySelector('.facetwp-facet-vertical');
  let currentVertical = document.querySelector('.vertical-list__item.checked');

  const mobileCurrentVertical = document.querySelector('.vertical-current-mobile li');
  const clearButton = document.querySelector('.filter-clear');

  const hubSort = document.querySelector('.hub-filter__sort');
  const sortButton = document.querySelector('.facetwp-sort-select');
  const customSortButton = document.querySelector('.hub-filter__sort-button');
  const customSortList = document.querySelector('.hub-filter__sort-list');

  let lastFocusedElement;

  if (hubFilter) {
    window.addEventListener('resize', moveElements);
    hubSearchToggler && hubSearchToggler.addEventListener('click', openSearchOptions);
    filterClose && filterClose.addEventListener('click', openSearchOptions);
    clearButton && clearButton.addEventListener('click', clearSelections);
    customSortButton && customSortButton.addEventListener('click', openSortOptions);

    // event delegation against facetwp ajax load
    document.addEventListener('click', onClick);
    init();
  } else {
    window.removeEventListener('resize', moveElements);
    document.removeEventListener('click', onClick);
  }

  function init() {
    if (hubPage && selectionsList && selectionsList.innerHTML !== '') {
      selections && selections.classList.add('has-selections');
      clearButton.removeAttribute('disabled');

      if (breakpoint === 'desktop') {
        hubFilter.classList.add('hub-filter--show-options');
      }
    } else {
      selections &&  selections.classList.remove('has-selections');
    }

    if (breakpoint === 'mobile' && verticalsMobileContainer) {
      moveVerticals();
    }

    if (breakpoint === 'desktop' && verticalsDesktopContainer) {
      moveSortButton();
    }

    handleGTMTracking();

    if (hubPage) {
      hasSelectionObserver();
      facetWPObserver();
      handleCustomFacets();
    }
  }

  function onClick(e) {
    const target = e.target;

    if (target.classList.contains('search-types-toggler')) {
      togglePostTypeOptions(e);
    }

    if (target.classList.contains('search-set-toggler')) {
      openChoices(e);
    }

    if (target.classList.contains('hub-filter__sort-item')) {
      sortResults(e);
    }

    if (target.classList.contains('vertical-list__item-button')) {
      // toggle off filter options
      if (breakpoint === 'desktop') {
        if (hubFilter.classList.contains('hub-filter--show-options')) {
          hubSearchToggler.click();
        }
      }

      if (breakpoint === 'mobile') {
        // Set Brand Color
        setCurrentVerticalMobile();
      }
    }

    if (target.classList.contains('facetwp-checkbox')) {
      const state = target.getAttribute('aria-checked');
      lastFocusedElement = document.activeElement;
      lastFocusedElement.focus();

      target.setAttribute('aria-checked', state === 'true' ? 'false' : 'true');
    }

    if (target.classList.contains('facetwp-selection-value')) {
      const dataValue = target.getAttribute('data-value');
      if (dataValue) {
        document.querySelector(`.facetwp-checkbox[data-value="${dataValue}"]`).click();
      }
    }
  }

  function openSearchOptions() {
    if (! hubFilter.classList.contains('hub-filter--show-options')) {
      hubFilter.classList.add('hub-filter--show-options');
      hubSearch.focus();

      if (breakpoint === 'mobile') {
        body.classList.add('overflow-hidden');
        hubSearch.setAttribute('role', 'dialog');
        a11yFocusTrap.trapFocus(hubSearch, document.activeElement);
        hubSearch.focus();
        hideElements('.hub-result, .hub-pager, .hub-filter__verticals--desktop, .hub-filter__selections, .hub-filter__sort', true);
      }
    } else {
      hubFilter.classList.remove('hub-filter--show-options');
      hubFilter.classList.add('options--is-closing');

      if (breakpoint === 'mobile') {
        body.classList.remove('overflow-hidden');
        a11yFocusTrap.unTrapFocus();
        hubSearchToggler.focus();
        hideElements('.hub-result, .hub-pager, .hub-filter__verticals--desktop, .hub-filter__selections, .hub-filter__sort', false);
      }

      setTimeout(() => {
        hubFilter.classList.remove('options--is-closing');
      }, 300);
    }
  }

  function togglePostTypeOptions(e) {
    const target = e.target;
    const setParent = target.closest('.hub-filter__search-types');

    if (! setParent.classList.contains('type--is-open')) {
      setParent.classList.add('type--is-open');
      target.setAttribute('aria-expanded', 'true');
    } else {
      setParent.classList.remove('type--is-open');
      target.setAttribute('aria-expanded', 'false');
    }
  }

  function openChoices(e) {
    const target = e.target;
    const setParent = e.target.closest('.hub-filter__search-set');

    if (! setParent.classList.contains('set--is-open')) {
      setParent.classList.add('set--is-open');
      target.setAttribute('aria-expanded', 'true');
    } else {
      setParent.classList.remove('set--is-open');
      target.setAttribute('aria-expanded', 'false');
    }
  }

  function openSortOptions() {
     if (! hubSort.classList.contains('hub-filter__sort--is-open')) {
      hubSort.classList.add('hub-filter__sort--is-open');
      customSortButton.setAttribute('aria-expanded', 'true');
      document.querySelector('.hub-filter__sort-list').focus();

      document.addEventListener("keydown", function(event) {
        switch (event.keyCode) {
          case 27: //esc
            closeSortOptions();
            break;
        }
      });
    } else {
      closeSortOptions();
    }
  }

  function closeSortOptions() {
    hubSort.classList.remove('hub-filter__sort--is-open');
    customSortButton.setAttribute('aria-expanded', 'false');
    customSortButton.focus();
  }

  // Move Verticals
  function moveVerticals() {
    breakpoint = body.getAttribute('data-breakpoint');
    verticals = document.querySelector('.facetwp-facet-vertical, .facet-vertical');

    if (breakpoint === 'mobile') {
      verticalsMobileContainer.appendChild(verticals);
      setCurrentVerticalMobile();
    } else {
      verticalsDesktopContainer.appendChild(verticals);
    }
  }

  function moveSortButton() {
    breakpoint = body.getAttribute('data-breakpoint');

    if (breakpoint === 'desktop') {
      verticalsDesktopContainer.parentNode.insertBefore(hubSort, verticalsDesktopContainer.nextSibling);
    } else {
      hubFilter.appendChild(hubSort);
    }
  }

  function moveElements() {
    if (verticalsMobileContainer || verticalsDesktopContainer) {
      moveVerticals();
      moveSortButton();
    }
  }

  function clearSelections() {
    setTimeout(() => {
      selections.classList.remove('has-selections');
      clearButton.setAttribute('disabled', 'true');
    }, 400);
  }

  function hasSelectionObserver() {
    const targetNode = document.querySelector('.filter-selections');
    const config = { attributes: true, childList: true, subtree: true };
    const callback = function(mutationsList, observer) {
      for(let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          // Toggle Class to hide 'Clear All' button
          if (targetNode.innerHTML === '') {
            clearSelections();
          } else {
            selections.classList.add('has-selections');
            clearButton.removeAttribute('disabled');

            if (breakpoint === 'mobile') {
              countSelected();
              setCurrentVerticalMobile();
            }
          }
        }
      }
    };
    const observer = new MutationObserver(callback);
    targetNode && observer.observe(targetNode, config);
  }

  function facetWPObserver() {
    const targetNode = document.querySelector('.facetwp-template');
    const config = { attributes: true, childList: true, subtree: true };
    const callback = function(mutationsList, observer) {
      for(let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          enableCardHover();
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }

  function handleCustomFacets() {
    const $ = jQuery;

    /* ======== Custom Filter Selection ======== */

    if (selectionsList) {
      populateSelections();
      FWP.hooks.addAction('facetwp/loaded', populateSelections);
    }

    /* ======== Custom Vertical Facet ======== */

    FWP.hooks.addAction('facetwp/refresh/radio', function($this, facet_name) {
      const selected_values = [];
      $this.find('.vertical-list__item.checked').each(function() {
        const val = $(this).attr('data-value');
        if (val !== '') {
          selected_values.push(val);
        }
      });
      FWP.facets[facet_name] = selected_values;
    });

    $(document).on('click', '.facetwp-type-radio .vertical-list__item:not(.checked)', function() {
      // Uncheck previously checked item and checked the clicked item.
      const is_checked = $(this).hasClass('checked');
      $(this).closest('.facetwp-facet').find('.vertical-list__item').removeClass('checked');
      if (! is_checked) {
        $(this).addClass('checked');
      }

      // Update selected vertical.
      FWP.parse_facets();

      // Clear other facets.
      const facets = ['platform', 'property', 'program', 'industry'];
      for (let i = 0; i < facets.length; i++) {
        if (FWP.facets[facets[i]]) {
          FWP.facets[facets[i]] = [];
        }
      }

      // Refresh content.
      FWP.frozen_facets = {};
      FWP.is_reset = true;
      FWP.autoload();
    });
  }

  function populateSelections() {
    const $ = jQuery;
    let selections = '';

    $.each(FWP.facets, function(key, val) {
      // Exclude vertical and facets without selected item.
      if (val.length < 1 || ! (typeof FWP.settings.labels[key] !== 'undefined') || 'vertical' === key) {
        return true; // skip this facet
      }

      let choices = val;
      const facet_type = $('.facetwp-facet-' + key).attr('data-type');
      choices = FWP.hooks.applyFilters('facetwp/selections/' + facet_type, choices, {
        'el': $('.facetwp-facet-' + key),
        'selected_values': choices
      });

      if (typeof choices === 'string') {
        choices = [{ value: '', label: choices }];
      }
      else if (! (typeof choices[0].label !== 'undefined')) {
        choices = [{ value: '', label: choices[0] }];
      }

      let values = '';
      $.each(choices, function(idx, choice) {
        values += '<button class="facetwp-selection-value" data-value="' + choice.value + '">' + FWP.helper.escape_html(choice.label) + '</button>';
      });

      selections += '<li data-facet="' + key + '">' + values + '</li>';
    });

    if (selections !== '') {
      selections = '<ul>' + selections + '</ul>';
    }

    selectionsList.innerHTML = selections;
  }

  function sortResults(e) {
    const target = e.target;
    const sortValue = target.getAttribute('data-value');

    closeSortOptions();

    customSortButton.querySelector('span').innerHTML = target.innerHTML;
    if (sortButton) {
      sortButton.value = sortValue;
    }

    if (FWP !== null && sortValue !== 'default') {
      FWP.extras.sort = sortValue;
      FWP.soft_refresh = !0;
      FWP.autoload();
    }
  }

  function enableCardHover() {
    setTimeout(() => Card(), 250);
  }

  function countSelected() {
    const searchTypes = document.querySelectorAll('.hub-filter__search-types');

    searchTypes.forEach(type => {
      const checked = type.querySelectorAll('.checked');
      const checkedLength = checked.length;
      const counter = type.querySelector('.search-types-counter');

      if (checkedLength > 0) {
        counter.innerHTML = checkedLength + ' selected';
      }
    });
  }

  function setCurrentVerticalMobile() {
    currentVertical = document.querySelector('.vertical-list__item.checked');

    mobileCurrentVertical.innerHTML = currentVertical.innerHTML;
    mobileCurrentVertical.setAttribute('data-brand', currentVertical.getAttribute('data-brand'));
  }

  function handleGTMTracking() {
    const $j = jQuery; // eslint-disable-line no-undef

    $j(document).on('click', '.facetwp-checkbox', function() {
      const filterCheckbox = $j(this);
      const filterName = filterCheckbox.attr('data-gtm-value');

      /**
       * Reverse logic because the adding and removing of the "checked" class
       * is being done in the BE.
       *  -- This script will trigger first before the PHP code.
       */
      if (! filterCheckbox.hasClass('checked')) {
        window.dataLayer.push({
          event: 'search',
          eventType: 'search filter select',
          searchTerms: filterName,
        });

        window.dataLayer.push({
          event: 'filter',
          eventType: 'filter select',
          filterFacet: filterName
        });
      }
    })
  }
};

export default HubFilter;
